/**
 * Move “How to care?” modal portal nodes to document.body so position:fixed overlays
 * and dialogs aren’t clipped by .Product (runs after main Product section reorders OffScreen).
 */
(function () {
  if (window.__howToCarePortalInit) {
    return;
  }
  window.__howToCarePortalInit = true;

  function portalHowToCareModalsToBody() {
    document.querySelectorAll('[data-how-to-care-portal]').forEach(function (el) {
      if (el.parentNode && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  function schedule() {
    setTimeout(portalHowToCareModalsToBody, 0);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
